
<template>
  <div>
    <v-dialog width="90%" v-model="dialog" persistent>
      <dialog-loading v-if="all_loadings"></dialog-loading>
      <v-card v-if="!all_loadings">
        <v-card-title>
          <v-icon left>mdi-swap-horizontal</v-icon>
          Transferência de Clientes entre carteiras
        </v-card-title>
        <v-card-text>
          <v-form ref="form" class="pa-1" style="overflow-y: auto; max-height:75vh; border: solid 1px #ddd; border-radius:7px">
            <div class="d-flex justify-center align-center flex-wrap ma-1">
              <v-autocomplete v-model="origin_id" :items="client_portfolios" item-text="attributes.name" item-value="id" :rules="[...required]" prepend-inner-icon="mdi-account-multiple" label="Origem"></v-autocomplete>
              <div class="d-flex flex-column justify-center align-center caption mx-2">
                <span>Enviar clientes para</span>
                <v-icon>mdi-arrow-right-thin</v-icon>
              </div>
              <v-autocomplete v-model="destination_id" :items="client_portfolios" item-text="attributes.name" item-value="id" :rules="[...required]" prepend-inner-icon="mdi-account-multiple-plus" label="Destino"></v-autocomplete>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close small @click="$router.push({name:'ClientPortfolios'})"></f-btn>
          <f-btn save small @click="transferClients()"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from "@/mixins/validations.js"

export default {
  name: 'TransferClientsToBetweenClientPortfolios',
  mixins: [validations],
  data() {
    return {
      dialog: true,
      origin_id: null,
      destination_id: null,
      client_portfolios:[],
      loading:{
        client_portfolios: false,
        saving: false
      },
    }
  },
  computed: { 
    all_loadings(){
      return this.loading.client_portfolios || this.loading.saving
    },
  },
  methods: {
    getData(){
      this.getClientPortfolios()
    },
    transferClients() {
      if(this.$refs.form.validate() && this.origin_id != null && this.destination_id != null){
        let transfer = this.prepareData()

        this.loading.saving = true
        Api.ClientPortfolio.transfer_clients(transfer).then(()=>{
          this.$router.push({name:'ClientPortfolios'})
          this.successSaved()
        }).finally(()=>{
          this.loading.saving = false
        })
      }else{
        this.missingFields()
      }
    },
    prepareData(){
      return {
        origin_id: this.origin_id,
        destination_id: this.destination_id,
      }
    },
    getClientPortfolios(){
      this.loading.client_portfolios = true
      Api.ClientPortfolio.index().then(r => r.data).then(data => {
        this.client_portfolios = [...data.data]
      }).finally(()=>{
        this.loading.client_portfolios = false
      })
    },
    originIsDestination(){
      if(this.origin_id == this.destination_id){
        this.$nextTick(() => {
          this.destination_id = null;
        });
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch:{
    origin_id(nv){
      this.originIsDestination()
    },
    destination_id(nv){
      this.originIsDestination()
    }
  }
}
</script>